import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export const Route = createFileRoute('/_auth/operator/payments/$id')({
  component: PaymentDetailPage,
});

function PaymentDetailPage() {
  const { id } = Route.useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate({ to: '/operator/payments' })}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          {t('common.back')}
        </Button>
        <h1 className="text-2xl font-bold tracking-tight">
          {t('payments.paymentDetails')}
        </h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Payment {id.slice(-8)}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Payment detail view for ID: {id}
          </p>
          {/* TODO: Implement full payment detail view */}
        </CardContent>
      </Card>
    </div>
  );
}
